import { cn } from "@omni/utils/styles";

import CalculationField, {
    CalculationFieldProps
} from "@/components/Calculator/Components/CalculationField/calculationField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";

type Props = {
    id: string;
    index: number;
    updateValues: (index: number, area: number[]) => void;
    name?: string;
    isLength?: boolean;
    values: number[];
};

const AreaField = ({
    id,
    index,
    updateValues,
    name,
    isLength,
    values
}: Props) => {
    const calculationPropsX: CalculationFieldProps = {
        name: "width",
        dimension: "width",
        unit: "m",
        setCalculationValue: (_: string, value: string) =>
            updateValues(index, [
                values[0],
                parseFloat(value.replace(",", "."))
            ]),
        sm: 4,
        md: 4
    };

    const calculationPropsY: CalculationFieldProps = {
        name: isLength ? "length" : "height",
        dimension: isLength ? "length" : "height",
        unit: "m",
        setCalculationValue: isLength
            ? (_: string, value: string) =>
                  updateValues(index, [
                      parseFloat(value.replace(",", ".")),
                      values[1]
                  ])
            : (_: string, value: string) =>
                  updateValues(index, [
                      parseFloat(value.replace(",", ".")),
                      values[1]
                  ]),
        sm: 4,
        md: 4
    };

    return (
        <Row
            id={id}
            className={cn("tw:mb-3")}
        >
            {name && (
                <Col xs={12}>
                    <h4 className={cn("tw:mb-0")}>
                        {name} {index + 1}
                    </h4>
                </Col>
            )}
            <CalculationField
                {...calculationPropsY}
                value={values[0]}
            />
            <CalculationField
                {...calculationPropsX}
                value={values[1]}
            />
            <Col
                sm={3}
                md={3}
                className={cn(
                    "tw:flex tw:flex-col tw:justify-end tw:text-end tw:max-sm:hidden"
                )}
            >
                <span className={cn("tw:my-2")}>
                    {(values[0] * values[1])
                        .toFixed(2)
                        .toString()
                        .replace(".", ",")}{" "}
                    m<sup>2</sup>
                </span>
            </Col>
        </Row>
    );
};

export default AreaField;
